import defaultI18nProvider from './defaultI18nProvider';
import translate from './translate';
import TranslationProvider from './TranslationProvider';
export { defaultI18nProvider, translate, TranslationProvider };
export var DEFAULT_LOCALE = 'en';
export * from './TranslationUtils';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-admin/node_modules/ra-core/esm/i18n/index.js
// module id = 185
// module chunks = 0